import React from 'react';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { AML_LEVEL_BASIC, DELIVERY_CASH_UNITELLER, MULTIPLE_AMOUNT_ISSUE } from 'apps/auth/constants/Constants';
import { ISRAEL } from 'apps/auth/constants/WellKnownCountries';
import { formatMoney } from 'apps/auth/helpers/formats';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { LimitsService } from 'apps/auth/services/LimitsService';

import ExceedTransactionLimit from './ExceedTransactionLimit';
import ViewPopup from './ViewPopup';

const ERR_INVALID_MAX_AMOUNT = 298;
const DefaultPopup = ({
    popupRef,
    defaultDecreaseAmountButtonClick,
    decreaseAmountButtonClick,
    value,
    maxAmount,
    messages,
    isFrom,
    extra,
    amountField,
    isBonus,
    currencyCode,
    deliveryMethod,
}) => {
    const { leftLimitAmount, profile, canMakeDraftTransaction, increaseLimit, hasOtherDeliveryOption, additionalAmlLimit } = extra;
    const isZeroRemainingProfileLimits = LimitsService.getZeroProfileLimitsErrors(value, canMakeDraftTransaction, profile);
    const toLeftLimitAmount = leftLimitAmount && extra?.commission?.convertRate && Number((+leftLimitAmount * +extra?.commission?.convertRate).toFixed(2));
    const leftLimit = isFrom ? leftLimitAmount : toLeftLimitAmount;
    const isNotZeroRemainingProfileLimits = !!(leftLimit && maxAmount && leftLimit < maxAmount);
    const isProfileSendingLimits = (isNotZeroRemainingProfileLimits || isZeroRemainingProfileLimits) && !canMakeDraftTransaction;
    const isAdditionalSendingLimits = additionalAmlLimit && value > additionalAmlLimit.left;
    const isZeroAdditionalLimits = additionalAmlLimit && LimitsService.getZeroAdditionalLimitsErrors(value, additionalAmlLimit);
    const isTransactionalLimits = maxAmount && value > maxAmount && !isProfileSendingLimits;
    const isShowGotItButton = isZeroRemainingProfileLimits && !increaseLimit;
    const isShowDeliveryOptions = hasOtherDeliveryOption && isTransactionalLimits && !isBonus && !isAdditionalSendingLimits;
    const isShowChangePickupButton = deliveryMethod === DELIVERY_CASH_UNITELLER && isTransactionalLimits;

    const isShowIncreaseLimitButton = (profile) => {
        if (profile?.countryId === ISRAEL && profile?.limitLvl > AML_LEVEL_BASIC) {
            return false;
        }
        return increaseLimit && !canMakeDraftTransaction && isProfileSendingLimits && amountField?.error?.code !== MULTIPLE_AMOUNT_ISSUE;
    };

    const getErrorTextBonus = () => {
        if (Number(value) > Number(maxAmount)) {
            const amountText = `${formatMoney(maxAmount)} ${currencyCode}`;
            return <DangerouslyHtml dangerouslyHtml={resolveArguments(messages.bonusAmountReached, [amountText])} />;
        } else if (leftLimitAmount && Number(value) > leftLimitAmount) {
            const amountText = `${formatMoney(isFrom ? leftLimitAmount : toLeftLimitAmount)} ${currencyCode}`;
            return <DangerouslyHtml dangerouslyHtml={resolveArguments(messages.bonusAmountLimitReached, [amountText])} />;
        } else if (isAdditionalSendingLimits) {
            return <DangerouslyHtml dangerouslyHtml={isFrom ? messages.additionalLimitErrorText : messages.errorTextAdditionalLimitLeftAmount} />;
        }
    };
    const getErrorTextUsual = () => {
        if (isProfileSendingLimits) {
            const errorText = isFrom || isZeroRemainingProfileLimits ? messages.errorText : messages.errorTextLeftAmount;
            return <DangerouslyHtml dangerouslyHtml={errorText || messages.errorTextThreeMonthLimit} />;
        } else if (isAdditionalSendingLimits) {
            return <DangerouslyHtml dangerouslyHtml={isFrom ? messages.additionalLimitErrorText : messages.errorTextAdditionalLimitLeftAmount} />;
        } else if (extra?.commission?.code === ERR_INVALID_MAX_AMOUNT && messages.errorText && !isTransactionalLimits) {
            return <DangerouslyHtml dangerouslyHtml={isFrom ? messages.errorText : messages.errorTextLeftAmount} />;
        } else {
            return (
                <ExceedTransactionLimit
                    isFrom={isFrom}
                    isShowDeliveryOptions={isShowDeliveryOptions}
                    isShowChangePickupButton={isShowChangePickupButton}
                    messages={messages}
                />
            );
        }
    };
    return (
        <ViewPopup
            isShowChangeAmountButton={!isZeroRemainingProfileLimits && !isZeroAdditionalLimits}
            isShowGotItButton={isShowGotItButton}
            isShowDeliveryOptions={isShowDeliveryOptions}
            isShowIncreaseLimitButton={isShowIncreaseLimitButton(profile)}
            isShowChangePickupButton={isShowChangePickupButton && !isBonus}
            deliveryMethod={deliveryMethod}
            defaultDecreaseAmountButtonClick={defaultDecreaseAmountButtonClick}
            decreaseAmountButtonClick={decreaseAmountButtonClick}
            popupRef={popupRef}
            errorText={isBonus ? getErrorTextBonus() : getErrorTextUsual()}
            profile={profile}
            messages={messages}
            arrowButtonText={messages.calcCommissionIncreaseLimit}
        />
    );
};
DefaultPopup.propTypes = {
    defaultDecreaseAmountButtonClick: PropTypes.func,
    decreaseAmountButtonClick: PropTypes.func,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    value: PropTypes.number,
    amountField: PropTypes.object,
    deliveryMethod: PropTypes.string,
    maxAmount: PropTypes.number,
    isFrom: PropTypes.bool,
    isBonus: PropTypes.bool,
    currencyCode: PropTypes.string,
    auth: PropTypes.object,
    extra: PropTypes.object,
    messages: PropTypes.object,
};
export default DefaultPopup;
